<script>
import axios from 'axios';

export default {
    name: 'OverviewText',
    data() {
        return {
            text: '',
            heading: '',
        };
    },
    methods: {
        getOverviewText() {
            axios.get('/properties/landing-page-detail').then(({ data }) => {
                this.text = data.overview;
                this.heading = data.heading;
            });
        },
    },
    mounted() {
        this.getOverviewText();
    },
};
</script>
<template>
    <div
        class="tw-px-4 lg:tw-px-24 xxl:tw-px-28 tw-w-full lg:tw-w-[670px] xxl:tw-w-[800px] tw-space-y-5"
    >
        <h1
            class="tw-text-darkGreen tw-leading-10 tw-text-[40px] md:tw-text-3xl lg: xl:tw-text-5xl tw-font-extrabold"
        >
            {{ heading }}
        </h1>
        <h2 class="tw-text-darkTeal tw-text-[18px] lg:tw-text-[16px]">
            {{ text }}
        </h2>
    </div>
</template>
